<template>
    <div>
        <div class="brand-box" :style="{'background-image': `url(${bgimg})`}" v-if="bgimg">
            <slot></slot>
        </div>
        <div class="cate-box" v-else>
            <div class="title"><span class="brand-box-line left"></span>{{title}}<span class="brand-box-line right"></span></div>
            <div class="subtitle">{{subtitle}}</div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "h-brand-box",
    props: {
        bgimg: String,
        title: String,
        subtitle: String
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>